(() => {
  if (window.__cartUpsellArrows) return;
  window.__cartUpsellArrows = true;

  // Each entry: the carousel to watch and how to find the arrows that belong to it.
  const CAROUSELS = [
    {
      selector: '.cart-drawer__complementary-products scroll-carousel',
      nav: (carousel) => carousel.closest('.cart-drawer__complementary-products')
        ?.querySelector('.complementary-products__header-nav:not([data-cart-recommendations-controls])')
    },
    {
      selector: 'scroll-carousel.upsells-products',
      nav: (carousel) => carousel.previousElementSibling?.querySelector('.upsell_controls')
    }
  ];
  const resizeObserver = new ResizeObserver((entries) => entries.forEach((entry) => update(entry.target)));
  let frame = 0;

  // Arrows only make sense when the cards overflow the carousel.
  function update(carousel) {
    const entry = CAROUSELS.find(({ selector }) => carousel.matches(selector));
    const nav = entry?.nav(carousel);
    if (!nav || carousel.clientWidth === 0) return;

    nav.hidden = carousel.scrollWidth <= carousel.clientWidth + 1;
  }

  function scan() {
    frame = 0;
    CAROUSELS.forEach(({ selector }) => document.querySelectorAll(selector).forEach((carousel) => {
      resizeObserver.observe(carousel);
      update(carousel);
    }));
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(scan);
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
